export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/martin-knize-bbf86c8b9293adb43210fc4c9e7448e9.jpg";